import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  label: {
    display: 'block',
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: theme.spacing(0.5, 0, 0, 0.5),
    textAlign: 'center',
    position: 'relative',
    backgroundClip: 'padding-box',
    '&:after': {
      content: '" "',
      position: 'absolute',
      borderBottom: '16px solid transparent',
      borderTop: '16px solid transparent',
      borderLeft: `16px solid ${theme.palette.primary.main}`,
      height: '0',
      width: '0',
      marginRight: '-16px',
      right: '0',
      top: '0',
    },
  },
}))

const Label: React.FC = ({ children }) => {
  const classes = useStyles()

  return (
    <Grid item xs={2}>
      <Typography variant='button' className={classes.label}>
        {children}
      </Typography>
    </Grid>
  )
}

export default Label
